import api from '../../plugins/api';

//подтвердить перерегистрацию авто в Freedom
const ffinReRegisterConfirm = ({ appealId }) => {
  return api.post('/api/bank/ffin/re-register/confirm', { appealId });
};

export default ffinReRegisterConfirm;
